import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../queries/useApplicationCache';

/**
 * Reads the Land Budget form for a given property from the React Query application cache.
 */
export function useBudgetLandCache(propertyGuid: string): IBudgetLand | undefined {
    return useApplicationCache(d =>
        d.information?.properties?.forms?.find(
            f => f.type === 'Land Budget' && f.propertyGuid === propertyGuid
        ) as IBudgetLand | undefined
    );
}
